import Vue from 'vue'
import VueRouter from "vue-router";
import HomeNew from '@/views/HomeNew.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {path: '/', component: HomeNew},
        {path: '/home-legacy', component: () => import(/* webpackChunkName: "home-legacy" */ '@/views/Home.vue')},
        {path: '/table', component: () => import(/* webpackChunkName: "table" */ '@/views/TableNew.vue')},
        {path: '/table-legacy', component: () => import(/* webpackChunkName: "table-legacy" */ '@/views/Table.vue')},
        {path: '/maker', component: () => import(/* webpackChunkName: "maker" */ '@/views/MakerNew.vue')},
        {path: '/maker-legacy', component: () => import(/* webpackChunkName: "maker-legacy" */ '@/views/Maker.vue')},
        {path: '/statistics', component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics.vue')},
        {path: '/announce', component: () => import(/* webpackChunkName: "announce" */ '@/views/Preview.vue')},
        {path: '/preview', component: () => import(/* webpackChunkName: "preview" */ '@/views/PreviewLatest.vue')},
        {path: '/lab/background', component: () => import(/* webpackChunkName: "lab-background" */ '@/views/LabBackground.vue')},
        {path: '/lab/tier-board', component: () => import(/* webpackChunkName: "lab-tier-board" */ '@/views/LabTierBoard.vue')},
        {path: '/login', component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')},
        {path: '/register', component: () => import(/* webpackChunkName: "register" */ '@/views/Register.vue')},
        {path: '/settings', component: () => import(/* webpackChunkName: "settings" */ '@/views/UserSetting.vue')},
        {path: '/admin', component: () => import(/* webpackChunkName: "admin" */ '@/views/Admin.vue')},
        {path: '/game/:id', component: () => import(/* webpackChunkName: "game" */ '@/views/Game.vue')},
        {path: '/404', component: () => import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue')},
        {path: '*', redirect: '/404'}
    ]
})

export default router
